/** A year as people read it: "356 BC", "AD 79", "1453". There is no year 0. */
export function fmtYear(y: number): string {
  if (y < 0) return `${-y} BC`;
  return y < 1000 ? `AD ${y}` : `${y}`;
}

/**
 * A year as people type it: "1453", "356 BC", "356 BCE", "AD 79", "79 CE", "c. 1450" or "-500". There is no
 * year 0, so "0" reads as AD 1. Anything else is not a year.
 */
export function parseYear(text: string): number | null {
  const m = /^\s*(?:c(?:a|irca)?\.?\s*)?(?:(ad|ce)\s*)?(-?\d{1,4})\s*(bc|bce|b\.c\.|ad|ce|a\.d\.)?\s*$/i.exec(text);
  if (!m?.[2]) return null;
  const n = parseInt(m[2], 10);
  if (/^b/i.test(m[3] ?? "")) return n > 0 ? -n : null;
  return n === 0 ? 1 : n;
}

const MONTHS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];
const MONTH_START = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];

/**
 * Where an event sits within its year: by its date when one is given ("11 July", "20 or 21 July", "July"),
 * so a crowded year spreads out as you zoom in. Undated events sit at the start of their year.
 */
export function whenOf(ev: { year: number; date?: string | undefined }): number {
  const m =
    /(?:(\d{1,2})\D{0,12}?)?\b(january|february|march|april|may|june|july|august|september|october|november|december)\b/i.exec(
      ev.date ?? "",
    );
  if (!m || !m[2]) return ev.year;
  const day = m[1] ? Math.min(31, parseInt(m[1], 10)) : 15;
  return ev.year + ((MONTH_START[MONTHS.indexOf(m[2].toLowerCase())] ?? 0) + day - 0.5) / 365;
}
